import { logEvent } from "firebase/analytics";
import { analytics } from "./firebaseConfig";
const logGA4Event = (eventName, params) => {
    logEvent(analytics, eventName, params);
};
export default logGA4Event;
